import { render } from "./LogEventsComponent.vue?vue&type=template&id=6ad3604f&scoped=true"
import script from "./LogEventsComponent.vue?vue&type=script&lang=js"
export * from "./LogEventsComponent.vue?vue&type=script&lang=js"

import "./LogEventsComponent.vue?vue&type=style&index=0&id=6ad3604f&scoped=true&lang=scss"

import exportComponent from "/Users/dmitriy-pc/Projects/docs.d-services.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ad3604f"]])

export default __exports__